<div class="container">
  <mat-card>
    <form [formGroup]="adhocQueryForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            @if (adhocQueryForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.SQL Query' | translate }}</mat-label>
            <textarea matInput required formControlName="query"></textarea>
            @if (adhocQueryForm.controls.query.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.SQL Query' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Insert into table' | translate }}</mat-label>
            <input matInput required formControlName="tableName" />
            @if (adhocQueryForm.controls.tableName.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Insert into table' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Table Fields' | translate }}</mat-label>
            <textarea matInput required formControlName="tableFields"></textarea>
            @if (adhocQueryForm.controls.tableFields.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Table Fields' | translate }} {{ 'labels.commons.are' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Email' | translate }}</mat-label>
            <input matInput formControlName="email" />
            @if (adhocQueryForm.controls.email.hasError('email')) {
              <mat-error>
                {{ 'labels.inputs.Email' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.invalid' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Report Run Frequency' | translate }}</mat-label>
            <mat-select formControlName="reportRunFrequency">
              @for (reportRunFrequency of reportRunFrequencyData; track reportRunFrequency) {
                <mat-option [value]="reportRunFrequency.id">
                  {{ reportRunFrequency.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          @if (adhocQueryForm.controls.reportRunFrequency.value === 5) {
            <mat-form-field>
              <mat-label>{{ 'labels.inputs.Custom Report Run Frequency (Days)' | translate }}</mat-label>
              <input type="number" matInput required formControlName="reportRunEvery" />
              @if (adhocQueryForm.controls.reportRunEvery.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Custom Report Run Frequency' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
              @if (adhocQueryForm.controls.reportRunEvery.hasError('min')) {
                <mat-error>
                  {{ 'labels.inputs.Custom Report Run Frequency' | translate }}
                  <strong>{{ 'labels.commons.must be larger than 0' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          <mat-checkbox labelPosition="before" formControlName="isActive">
            {{ 'labels.inputs.Active' | translate }}
          </mat-checkbox>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!adhocQueryForm.valid"
          *LOSxHasPermission="'CREATE_ADHOC'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
